import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'adminEvaluation'
const initialState = {
  list: null,
  adminRatingList: null,
  noteList: null,
  artifactList: null,
  goalRatingList: null,
  report: null
}

export const search = createApiAction('adminEvaluation/search', client.search('/api/evaluation/admin/provider/main'))
export const get = createApiAction('adminEvaluation/get', client.retrieve('/api/evaluation/admin/provider/main/:id'))
export const save = createApiAction('adminEvaluation/save', client.save('/api/evaluation/admin/provider/main'))

export const getReport = createApiAction('adminEvaluation/getReport', client.retrieve('/api/evaluation/admin/provider/report/:id'))

export const artifactSearch = createApiAction('adminEvaluation/artifactSearch', client.search('/api/evaluation/admin/provider/artifact'))
export const goalRatingSearch = createApiAction('adminEvaluation/goalRatingSearch', client.search('/api/evaluation/admin/provider/goal-rating'))

export const ratingSearch = createApiAction('adminEvaluation/ratingSearch', client.search('/api/evaluation/admin/provider/rating'))
export const ratingSave = createApiAction('adminEvaluation/ratingSave', client.save('/api/evaluation/admin/provider/rating'))
export const ratingGet = createApiAction('adminEvaluation/ratingGet', client.retrieve('/api/evaluation/admin/provider/rating/:id'))

export const noteSearch = createApiAction('adminEvaluation/noteSearch', client.search('/api/evaluation/admin/provider/note'))
export const noteSave = createApiAction('adminEvaluation/noteSave', client.save('/api/evaluation/admin/provider/note'))
export const noteGet = createApiAction('adminEvaluation/noteGet', client.retrieve('/api/evaluation/admin/provider/note/:id'))
export const noteDelete = createApiAction('adminEvaluation/noteDelete', client.destroy('/api/evaluation/admin/provider/note/:id'))

const update = (state, action) => {
  const updatedItem = action.payload;

  state.list = state.list.map(item =>
    item.id === updatedItem.id ? { ...item, ...updatedItem } : item
  );
};

const updateNote = (state, action) => {
  const updatedNote = action.payload;

  if (state.noteList.some(item => item.id === updatedNote.id)) {
    state.noteList = state.noteList.map(item =>
      item.id === updatedNote.id ? { ...item, ...updatedNote } : item
    );
  } else {
    state.noteList = [...state.noteList, updatedNote];
  }
};

const updateRating = (state, action) => {
  const rating = action.payload;
  const { standardId, id: ratingId } = rating;

  const updatedList = state.adminRatingList.map(item => {
    if (item.id === standardId) {
      const updatedRatings = item.adminEvaluationRatings.map(r =>
        r.id === ratingId ? rating : r
      );

      const isRatingPresent = item.adminEvaluationRatings.some(r => r.id === ratingId);
      return {
        ...item,
        adminEvaluationRatings: isRatingPresent
          ? updatedRatings
          : [...item.adminEvaluationRatings, rating],
      };
    }
    return item;
  });

  const isBucketPresent = state.adminRatingList.some(item => item.id === standardId);
  state.adminRatingList = isBucketPresent
    ? updatedList
    : [...state.adminRatingList, { id: standardId, adminEvaluationRatings: [rating] }];
};

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearEvaluation: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(artifactSearch.fulfilled, (state, action) => {
        state.artifactList = action.payload
      })
      .addCase(goalRatingSearch.fulfilled, (state, action) => {
        state.goalRatingList = action.payload
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)

      //RATING
      .addCase(ratingSearch.fulfilled, (state, action) => {
        state.adminRatingList = action.payload
      })
      .addCase(ratingSave.fulfilled, updateRating)
      // .addCase(ratingDelete.fulfilled, (state, action) => {
      //   state.adminRating = state.adminRating.filter(item => item.id !== action.payload.id)
      // })

      //NOTES
      .addCase(noteSearch.fulfilled, (state, action) => {
        state.noteList = action.payload
      })
      .addCase(noteGet.fulfilled, updateNote)
      .addCase(noteSave.fulfilled, updateNote)
      .addCase(noteDelete.fulfilled, (state, action) => {
        state.noteList = state.noteList.filter(item => item.id !== action.payload.id)
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.report = action.payload
      })
  },
})

export const { clearEvaluation } = sessionSlice.actions
export default sessionSlice.reducer
